import React, { useState } from 'react';
import { useAtom } from 'jotai';
import { siteDataAtom } from '../../atoms/SiteDataAtom';
import {
  Card,
  CardBody,
  CardFooter,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import DynamicGauge from '../../components/tables-charts/DynamicGauge';

const PowerCard = () => {
  const [siteData] = useAtom(siteDataAtom);
  const [selectedMetric, setSelectedMetric] = useState('Power');
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const metrics = {
    Power: { value: siteData.Pturb, unit: 'kW', color: '#919e8b', max: 20 },
    RPM: { value: siteData.RPMMax, unit: 'RPM', color: '#d87c7c', max: 150 },
    Grid: { value: siteData.Vgrid, unit: 'V', color: '#61a0a8', max: 270 },
    Vdc: { value: siteData.Vdc, unit: 'V', color: '#61a0a8', max: 650 },
  };

  return (
    <Card className="d-flex text-center justify-content-center">
      <CardBody>
        <DynamicGauge
          value={metrics[selectedMetric].value}
          color={metrics[selectedMetric].color}
          max={metrics[selectedMetric].max}
        />
      </CardBody>
      <CardFooter>
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
          <DropdownToggle caret>
            {selectedMetric} {metrics[selectedMetric].value || 0} {metrics[selectedMetric].unit}
          </DropdownToggle>
          <DropdownMenu>
            {Object.keys(metrics).map((metric) => (
              <DropdownItem
                key={metric}
                onClick={() => setSelectedMetric(metric)}
              >
                {metric}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </CardFooter>
    </Card>
  );
};

export default PowerCard;

